import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { AutoKeyViewModel } from 'projects/Administration/src/app/business-entities/auto-key-model';
import { AutoKeyBusinessService } from 'projects/Administration/src/app/business-services/auto-key.service';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';

@Component({
  selector: 'app-view-auto-key',
  templateUrl: './view-auto-key.component.html',
  styleUrls: ['./view-auto-key.component.css']
})
export class ViewAutoKeyComponent implements OnInit {
  autoKeyId : number
  //id: number
  logo: {
    name: string;
    path: string;
    pngPath: string;
  }
  autoKeyDetails: AutoKeyViewModel;
  licensePlateClass: string;

  constructor(
    private spinner: NgxSpinnerService,
    private service: AutoKeyBusinessService,
    private globalSetting: GlobalSetting,
    private activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.autoKeyId= this.service.autoKeyId;
    this.service.isEdit = true;
    this.licensePlateClass = this.globalSetting.getGlobalLicencePlate();
    this.getAutoKeyDetails(this.autoKeyId);
  }
  async getAutoKeyDetails(id: number) {
    this.spinner.show();
    await this.service.getAppointmentAutoKeyDetail(id).then(res => {
      if (res) {
        this.autoKeyDetails = this.autoKeyMapper(res)
      }
    })
    this.spinner.hide();
  }
  autoKeyMapper(data: AutoKeyViewModel) {
    let supperArray = [];
    if (data) {
      const element = data;
      const single = Object();
      single.id = element.id;
      single.appointmentId = element.appointmentId;
      single.licensePlate = element.licensePlate;
      single.model = element.model;
      single.workorderNumber = element.workorderNumber;
      single.status = element.status;
      single.brand = element.brand;
      single.customerName = element.customerName;
      single.dealerName = element.dealerName;
      single.mobile = element.mobile;
      single.date = element.lockerAssignDate ? element.lockerAssignDate : null;
      single.lockerId = element.kioskLocationName + '  ' + element.lockerId;
      single.lockerName =  element.lockerName;
      single.appointmentDate = element.appointmentDate ? element.appointmentDate : null;
      single.exchangeMethod = element.exchangeMethodName;

      supperArray.push(single)
    }
    return supperArray[0];
  }
  OnClose() {
    this.activeModal.dismiss('Cross click')
  }
}

